module.exports = __webpack_public_path__ + "img/en-logo.637dd2b6.png";